// UploadDocumentPopUp.tsx
import React, { useState, useRef, useEffect } from 'react';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import './UploadDocumentPopUp.css';
import { DeleteOutlined, DesktopOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import FoldersAndSubjects from '../_FoldersAndSubjects';
import { setReloadFilesData } from '../../app-context/filesSlice';
import { useDispatch } from 'react-redux';
import UploadDocumentFromScanner from './_UploadDoumentPromScanner'

interface UploadDocumentPopUpProps {
    config: any; // Config object containing customerId and optional relationId
    onClose: () => void;
    fromPolicy?: string; // Optional prop to indicate if this is from policy
    relationType: number; // Optional prop to indicate relation type (e.g., 2 for policy, 3 for rider)
    policyItem?: any; // Optional prop to pass policy item data
    onSetHasNewDocument: () => void; // Optional callback to set hasNewDocument state
}

type FileEntry = {
    id: string;
    file: File;
    name: string;
    size: number;
    progress: number;
    url?: string;
    uploaded: boolean;
    // type?: string; // Added type for file type
    documentTypeId?: string; // Added DocumentTypeId for file association. ... titleId
    folderId?: string; // Added folder ID for file association
    relationType?: string; // Added RelationType for file association
    relationId?: string; // Added RelationId for file association
};

export default function UploadDocumentPopUp({ config, onClose, fromPolicy, relationType, policyItem, onSetHasNewDocument }: UploadDocumentPopUpProps) {
    const customerCardModel = useRef(new CustomerCardModel()).current;

    const dispatch = useDispatch();
    const [folders, setFolders] = useState<any[]>([]);

    const [newTitleTypeName, setNewTitleTypeName] = useState('');
    const [fileTitleTypes, setFileTitleTypes] = useState<any[]>([]);
    const [files, setFiles] = useState<FileEntry[]>([]);

    const [userId, setUserId] = useState<string>('');
    const [relationTypes, setRelationTypes] = useState<any[]>([]);
    const [relationList, setRelationList] = useState<any[]>([]);

    const [showRelationDataList, setShowRelationDataList] = useState<boolean>(false);
    const [finalRelationList, setFinalRelationList] = useState<any[]>([]);

    const [uploadMode, setUploadMode] = useState<string>("files");


    useEffect(() => {
        console.log('useEffect-policyItem', policyItem)

        const loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            // Initialize folders based on user data if needed
            // For example, you could fetch folders from an API or set default ones
            setUserId(user.id);
        }
        init()
    }, []);

    const init = async () => {

        const resp = await customerCardModel.customerDocumentsGetFoldersForCustomer(config.customerId);
        if (resp && Array.isArray(resp)) {
            setFolders(resp);
        } else {
            console.error('Failed to fetch folders:', resp);
        }

        const relationTypes = await customerCardModel.getRelationTypes();
        if (relationTypes) {
            // If relationTypes is an array, add the new item; if it's an object, adjust accordingly
            const castingArray: any[] = Object.values(relationTypes);
            let newRelationTypes = castingArray.map((item: any) => ({
                id: item.id,
                name: item.name,
                description: item.description || ''
            }));
            newRelationTypes.unshift({
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            });
            // remove the item with name 'Treatment' or name 'Signing' or name 'Rider' or name 'Ofer'
            newRelationTypes = newRelationTypes.filter((item: any) => {
                return item.name !== 'Treatment' && item.name !== 'Signing' && item.name !== 'Offer';
            });


            setRelationTypes(newRelationTypes);
        } else {
            // Fallback if relationTypes is not an array
            setRelationTypes([{
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            }]);
            console.error('Relation types is not an array:', relationTypes);
        }


        // Fetch them from the API and store them
        const titles = await customerCardModel.customerDocumentsGetTitles();
        if (titles && Array.isArray(titles)) {
            setFileTitleTypes(titles);
            localStorage.setItem('customerDocumentsTitle', JSON.stringify(titles));
        } else {
            console.error('Failed to fetch titles:', titles);
            setFileTitleTypes([]);
        }

        let relationData = null;
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${config.customerId}`);
        if (storedRelations) {
            relationData = JSON.parse(storedRelations);
            console.log('storedRelations-relationDate-157', relationData)
        } else {
            relationData = await customerCardModel.treatmentsLoadRelations(config.customerId);
            sessionStorage.setItem(`treatmentsRelations-${config.customerId}`, JSON.stringify(relationData));
        }
        if (relationData) {
            // localStorage.setItem(`treatmentsRelations-${config.customerId}`, JSON.stringify(relationData));

            let leadsList = relationData.leads.map((lead: any) => ({
                id: lead.id,
                name: lead.identifier || '',
                type: 'Lead',
            }));
            let policiesList = relationData.policies.map((policy: any) => ({
                id: policy.id,
                name: getCompulsoryRouteId(policy) + " - " + policy.policyNumber + "/" + (policy.additionNumber ? policy.additionNumber : ''), //. add additional number before policy number and add - with branch number
                type: 'Policy',

            }));
            let suesList = relationData.sues.map((sue: any) => ({
                id: sue.id,
                name: sue.sueNumber || '',
                type: 'Sue',
            }));
            let riderList = relationData.riders.map((rider: any) => ({
                id: rider.id,
                name: rider.subscriberNumber || '',
                type: 'Rider',
            }));
            let newlist = [...leadsList, ...policiesList, ...suesList, ...riderList];
            setRelationList(newlist);
        }
    }

    const getCompulsoryRouteId = (policy: any) => {
        if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.vehiclePolicyType == 6) {
            return policy.policyAdditionDetails.route.compulsoryRouteId ? policy.policyAdditionDetails.route.compulsoryRouteId : ""
        } else if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.routeId) {
            return policy.policyAdditionDetails.route.routeId ? policy.policyAdditionDetails.route.routeId : "";
        }
        return "";
    }

    const onFilesAdded = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const list = evt.target.files;
        if (!list) return;
        const newEntries = Array.from(list).map((f) => ({
            id: `${Date.now()}-${f.name}`,
            file: f,
            name: f.name,
            size: f.size,
            progress: 0,
            uploaded: false,
        }));
        setFiles((prev) => [...prev, ...newEntries]);
        evt.target.value = '';
    };

    const convertBase64 = (file: File) =>
        new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (e) => reject(e);
        });


    const uploadFile = async (entry: FileEntry) => {
        // if (!selectedFolder || !selectedType) return;
        // set progress to 10% immediately
        setFiles((f) =>
            f.map((x) => (x.id === entry.id ? { ...x, progress: 10 } : x))
        );

        try {
            console.log('uploadFile-config.relationId', config.relationId)
            console.log('uploadFile-relationTypes', relationTypes)
            console.log('uploadFile-entry', entry)

            const base64 = await convertBase64(entry.file);
            const payload = {
                customerId: config.customerId,
                userId: userId,
                file: base64,
                name: entry.name,
                customerDocumentFolderId: entry.folderId || '',
                titleId: entry.documentTypeId || '',
                relationType: relationType > -1 ? relationType : entry.relationType, // Added relationType for file association. If from policy and itemType is "policy" set to 2, if "rider" set to 3
                relationId: config.relationId && config.relationId.length > 0 ? config.relationId : entry.relationId || '', // Added relationId for file association
            };
            const resp = await customerCardModel.customerDocumentsCreateFile(payload);
            // on success, mark 100% and record URL
            setFiles((f) =>
                f.map((x) =>
                    x.id === entry.id
                        ? {
                            ...x,
                            progress: 100,
                            uploaded: true,
                            url: resp.downloadUrl || URL.createObjectURL(entry.file),
                        }
                        : x
                )
            );

            onSetHasNewDocument(); // Call the callback to set hasNewDocument state
        } catch (err) {
            console.error('Upload error for', entry.name, err);
            setFiles((f) =>
                f.map((x) =>
                    x.id === entry.id ? { ...x, progress: 0 } : x
                )
            );
        }
    };

    const displayFile = (url?: string) => {
        if (url) window.open(url, '_blank');
    };

    const deleteFile = (id: string) => {
        setFiles((f) => f.filter((x) => x.id !== id));
        // TODO: call delete API if already uploaded
    };

    const createFolder = async (obj: any, newFolderName: string) => {
        if (!newFolderName.trim()) return;

        let resp = await customerCardModel.customerDocumentsCreateFolder({
            name: newFolderName,
            customerId: config.customerId
        })
        if (!resp || !resp.id) {
            console.error('Failed to create folder:', resp);
            return;
        }
        // add resp to folders
        const id = resp.id; // Use the ID from the response
        console.log('New folder created:', resp);

        setFolders((f) => [...f, resp]);
        onSelectFolder(obj, id);

    };


    const createType = async (obj: any, newTitleTypeName: string) => {
        if (!newTitleTypeName.trim()) return;
        let resp = await customerCardModel.customerDocumentsCreateTitle({
            name: newTitleTypeName
        });
        if (!resp || !resp.id) {
            console.error('Failed to create type:', resp);
            return;
        }
        // add resp to fileTitleTypes
        const id = resp.id; // Use the ID from the response
        console.log('New type created:', resp);
        setFileTitleTypes((fileTitle) => [...fileTitle, resp]);
        setNewTitleTypeName('');
        onSelectType(obj, id);
    }


    const onSelectFolder = (obj: any, value: string) => {
        if ((value || value == "") && obj && obj.id) {
            const file = files.find((file: FileEntry) => file.id === obj.id);
            if (file) {
                // Update the folderId of the file
                file["folderId"] = value;
                // Update the state with the modified file
                const updatedFiles = files.map((x: any) => (x.id === file.id ? file : x));
                setFiles(updatedFiles);
            }
        }
    };

    const onSelectType = (obj: any, value: string) => {
        if ((value || value == "") && obj && obj.id) {
            console.log('onSelectType-obj', obj, 'value', value);
            const file = files.find((file: FileEntry) => file.id === obj.id);
            if (file) {
                // Update the type of the file
                file["documentTypeId"] = value;
                console.log('onSelectType-file', file)
                // Update the state with the modified file
                const updatedFiles = files.map((x: any) => (x.id === file.id ? file : x));
                console.log('onSelectType-updatedFiles', updatedFiles)

                setFiles(updatedFiles);
                console.log('111', 111)
            }
        }
    };

    const onSelectRelationType = (obj: any, value: string) => {
        if (value && obj && obj.id) {
            const file = files.find((file: FileEntry) => file.id === obj.id);
            if (file) {
                // Update the relationType of the file
                file["relationType"] = value;
                // Update the state with the modified file
                const updatedFiles = files.map((x: any) => (x.id === file.id ? file : x));
                setFiles(updatedFiles);

                let relationType = relationTypes.find((rt) => rt.id === parseInt(value));
                let relationDataList = relationList.filter((rl) => rl.type == relationType.name);

                if (relationDataList && relationDataList.length > 0) {
                    // If there are related items, you can handle them here
                    setShowRelationDataList(true);
                    setFinalRelationList(relationDataList);
                }
            }
        }
    }

    const onSelectRelationId = (obj: any, value: string) => {
        if (value && obj && obj.id) {
            const file = files.find((file: FileEntry) => file.id === obj.id);
            if (file) {
                // Update the relationId of the file
                file["relationId"] = value;
                // Update the state with the modified file
                const updatedFiles = files.map((x: any) => (x.id === file.id ? file : x));
                setFiles(updatedFiles);
            }
        }
    };

    const deleteFolder = async (id: string) => {
        if (!id) return;
        const resp = await customerCardModel.customerDocumentsDeleteFolder(id);
        if (resp) {
            setFolders((f) => f.filter((x) => x.id !== id));
            setFiles((f) => f.map((x) => ({ ...x, folderId: '' }))); // Reset folderId for files in this folder
        } else {
            console.error('Failed to delete folder:', resp);
        }
    };

    const getNameInHebrew = (name: string) => {
        if (!name) return name;
        // Check if the name exists in the dictionary and return its Hebrew name
        // If not found, return the original name
        switch (name) {
            case 'Policy':
                return 'פוליסה';
            case 'Lead':
                return 'ליד';
            case 'Sue':
                return 'תביעה';
            case 'Ofer':
                return 'הצעה';
            case 'Rider':
                return 'ריידר';
            case 'Signing':
                return 'חתימה';
            case 'Treatment':
                return 'טיפול שוטף';
            default:
                return name; // Return the original name if not found in the dictionary 
        }
    }

    const onCloseFileUpload = () => {
        onClose();
        dispatch(setReloadFilesData(true)); // Mark files data for reload
    }

    return (
        <div className="udp-modal-overlay">
            <div className="udp-modal">
                <h2 className="udp-title">העלאת קבצים</h2>

                 <div
                        className="udp-dropzone"
                    >
                        <div className="udp-cloud-icon">☁️</div>
                        <p>גרור קבצים לכאן או לחץ כדי להעלות</p>
                        <input
                            id="udp-file-input"
                            type="file"
                            multiple
                            onChange={onFilesAdded}
                            className="udp-file-input"
                        />
                    </div>
                {/* DROPZONE */}


                {/* POLICY INFO */}
                {policyItem && policyItem.policyAdditionDetails &&
                    <div className="udp-policy-info">

                        <div><b>פוליסה: {policyItem.policyAdditionDetails.route.compulsoryRouteId + "-" + policyItem.policyNumber + "/" + policyItem.additionNumber}</b></div>

                        {policyItem.policyAdditionDetails.vehicle &&
                            <div>
                                <b>רכב - רישוי: {policyItem.policyAdditionDetails.vehicle.licenseNumber ? policyItem.policyAdditionDetails.vehicle.licenseNumber : ""}</b>
                            </div>
                        }
                    </div>
                }

                {/* Rider INFO */}
                {policyItem && policyItem.itemType && policyItem.itemType == "rider" &&
                    <div className="udp-policy-info">
                        <div><b>ריידר: {policyItem.additionNumber + " - " + policyItem.subscriberNumber}</b></div>
                    </div>
                }


                {/* FILE LIST */}
                <table className="udp-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>שם הקובץ</th>
                            <th>שם תיקייה</th>
                            <th>סוג נושא</th>
                            {fromPolicy && fromPolicy == "0" && <>
                                <th>סוג שיוך</th>
                                <th>שיוך</th>
                            </>}
                            <th>התקדמות</th>
                            <th>גודל</th>
                            <th>פעולות</th>
                        </tr>
                    </thead>
                    <tbody>
                        {files.map((f: any, idx) => (
                            <tr key={f.id}>
                                <td>{idx + 1}</td>
                                <td>{f.name}</td>

                                <FoldersAndSubjects
                                    file={f}
                                    idx={idx}
                                    folders={folders}
                                    onSelectFolder={onSelectFolder}
                                    createFolder={createFolder}
                                    fileTitleTypes={fileTitleTypes}
                                    onSelectType={onSelectType}
                                    createType={createType}
                                />

                                {fromPolicy && fromPolicy == "0" &&
                                    <>
                                        <td>
                                            <select
                                                value={f.relationType}
                                                onChange={(e: any) => onSelectRelationType(f, e.target.value)}
                                                disabled={f.uploaded}
                                            >
                                                <option value={-1}>
                                                    בחר סוג שיוך
                                                </option>
                                                {relationTypes.filter(rt => rt.id !== -1).map((rt) => (
                                                    <option key={rt.id} value={rt.id}>
                                                        {getNameInHebrew(rt.name)}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            {showRelationDataList && finalRelationList && finalRelationList.length > 0 && (
                                                <select
                                                    value={f.relationId}
                                                    onChange={(e: any) => onSelectRelationId(f, e.target.value)}
                                                    disabled={f.uploaded}
                                                >
                                                    <option value={-1}>
                                                        בחר שיוך
                                                    </option>
                                                    {finalRelationList.map((rl) => (
                                                        <option key={rl.id} value={rl.id}>
                                                            {rl.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </td>
                                    </>
                                }
                                <td>
                                    <progress value={f.progress} max={100} />
                                </td>
                                <td>{(f.size / 1024).toFixed(2)} KB</td>
                                <td className="udp-actions">
                                    {!f.uploaded && (
                                        <>
                                            <Tooltip title="העלאה">
                                                <button className="udp-upload-btn" onClick={() => uploadFile(f)}>
                                                    העלאה
                                                </button>
                                            </Tooltip>

                                            <Tooltip title="מחיקה">
                                                <DeleteOutlined style={{
                                                    fontSize: '28px',
                                                    marginLeft: '10px',
                                                    color: '#186cc7'
                                                }} onClick={() => deleteFile(f.id)} />
                                            </Tooltip>
                                        </>
                                    )}
                                    {f.uploaded && f.url && (
                                        <>
                                            <Tooltip title="הצגת">
                                                <DesktopOutlined style={{
                                                    fontSize: '28px',
                                                    marginLeft: '10px',
                                                    color: '#186cc7'
                                                }} onClick={() => displayFile(f.url)}
                                                />
                                            </Tooltip>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* FOOTER */}
                <div className="udp-footer">
                    <div>{files.length}/20 קבצים הועלו</div>
                    <button className="udp-close-btn" onClick={onCloseFileUpload}>
                        סגור
                    </button>
                </div>
            </div>
        </div>
    );
}
